import React, { useEffect, useState } from 'react';
import './ScrollIndicator.css';

const ScrollIndicator: React.FC = () => {
  const [activeSection, setActiveSection] = useState('hero');
  const [isVisible, setIsVisible] = useState(false);

  const sections = [
    { id: 'hero', label: 'Home' },
    { id: 'power', label: 'Power' },
    { id: 'carrier', label: 'Carrier' },
    { id: 'agents', label: 'Agents' },
    { id: 'ai', label: 'AI' },
    { id: 'tracking', label: 'Tracking' },
    { id: 'monitor', label: 'Monitor' },
    { id: 'integration', label: 'Integration' },
    { id: 'compliance', label: 'Compliance' },
    { id: 'pricing', label: 'Pricing' }
  ];

  useEffect(() => {
    let ticking = false;
    
    const handleScroll = () => {
      if (!ticking) {
        requestAnimationFrame(() => {
          const scrollTop = window.scrollY;
          const headerHeight = 80;
          
          // Find which section is currently in view
          let currentSection = 'hero';
          
          sections.forEach(section => {
            const element = document.getElementById(section.id);
            if (element) {
              const elementTop = element.offsetTop - headerHeight;
              const elementBottom = elementTop + element.offsetHeight;
              
              if (scrollTop >= elementTop && scrollTop < elementBottom) {
                currentSection = section.id;
              }
            }
          });
          
          setActiveSection(currentSection);
          
          // Show indicator after scrolling down a bit
          setIsVisible(scrollTop > 200);
          
          ticking = false;
        });
        ticking = true;
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId: string) => {
    const element = document.getElementById(sectionId);
    if (element) {
      const headerHeight = 80;
      const elementPosition = element.offsetTop - headerHeight;
      
      window.scrollTo({
        top: elementPosition,
        behavior: 'smooth'
      });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="scroll-indicator">
      <div className="indicator-dots">
        {sections.map((section) => (
          <button
            key={section.id}
            className={`indicator-dot ${activeSection === section.id ? 'active' : ''}`}
            onClick={() => scrollToSection(section.id)}
            title={section.label}
            aria-label={`Go to ${section.label} section`}
          >
            <span className="dot"></span>
            <span className="section-label">{section.label}</span>
          </button>
        ))}
      </div>
    </div>
  );
};

export default ScrollIndicator;
